export const REASON_TYPES = [
  ["aumento", "Aumento salarial"], ["promocao", "Promoção"], ["inflacao", "Ajuste inflação / custo de vida"],
  ["funcao", "Alteração de função"], ["correcao", "Correção de erro"], ["reducao", "Redução acordada"], ["outro", "Outro"],
];
export const reasonLabel = (t) => REASON_TYPES.find(([k]) => k === t)?.[1] || t;
